import { merge } from "lodash";
import baseSurvey from "../../data/survey.json";
import assuranceVieSurvey from "../../data/survey.assurance-vie.json";
import { getJSONFromUrlParams } from "./URLParser";

/**
 * Charge le survey de base et applique les variantes selon l'origin
 * @returns {Object} Le survey configuré selon l'origin
 */
export default function loadSurvey() {
  // Vérifier si on est côté client (window existe)
  if (typeof window === "undefined") {
    // Si on est côté serveur, retourner le survey de base
    return baseSurvey;
  }

  try {
    const urlParams = getJSONFromUrlParams();
    const origin = urlParams.origin;

    // Si l'origin est "assurance-vie", charger la variante
    if (origin === "assurance-vie") {
      // Merge profond pour combiner les deux surveys
      // La variante surcharge les valeurs du survey de base
      return merge({}, baseSurvey, assuranceVieSurvey);
    }
  } catch (error) {
    // En cas d'erreur, retourner le survey de base
    console.warn("Erreur lors du chargement du survey, utilisation du survey de base", error);
    return baseSurvey;
  }

  // Par défaut, retourner le survey de base
  return baseSurvey;
}
